<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-6">
        <masked-text-box :label="$t('workFileTracking.identification.workFileNumber')" mask="4#######" pattern="[0-9]{8}" required :labelTooltip="$t('workFileTracking.identification.workFileNumberTooltip')" data-cy="works-file--id" v-model="worksFileId"></masked-text-box>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-6">
        <text-box :label="$t('workFileTracking.identification.workZipCode')" :rules="{ 'zip-code': true, required: true }" v-model="zipCode"></text-box>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch, Inject } from 'vue-property-decorator'
import { WorkFileIdentification } from '@/models'

@Component
export default class WorkFileIdentificationForm extends Vue {
  //#region [Property]
  @Prop({ type: Object, required: false }) public readonly value!: WorkFileIdentification | null
  //#endregion

  //#region [Computed]
  public get worksFileId(): string | null {
    return this.value ? this.value.worksFileId : null
  }
  public set worksFileId(val: string | null) {
    this.change(val, this.zipCode)
  }

  public get zipCode(): string | null {
    return this.value ? this.value.zipCode : null
  }
  public set zipCode(val: string | null) {
    this.change(this.worksFileId, val)
  }
  //#endregion

  //#region [Emit]
  @Emit('input')
  public change(worksFileId: string | null, zipCode: string | null): WorkFileIdentification | null {
    if (worksFileId !== null || zipCode !== null) {
      return { worksFileId, zipCode }
    } else {
      return null
    }
  }
  //#endregion
}
</script>